var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("CDR")]),_c('activity-overview',{attrs:{"innerTabHeaders":_vm.innerTabHeaders,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }